const styles = theme => ({
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'auto',
    width: '100%'
  },

  '@media (min-width: 768px)': {
    content: {
      overflow: 'hidden'
    }
  }
});

export { styles };

// Commit trace: 2025-12-06T02:30:33 - chore: minor maintenance in App.styles.js

// Commit trace: 2025-12-07T21:37:07 - docs: clarify parameter types in App.styles.js

// Commit trace: 2026-02-24T13:16:34 - perf: improve memory usage in App.styles.js
